<template>
  <Card
    :isCustomTooltip="false"
    :title="$t('rc_campaign_model')"
    :hint="$t('rc_cpc_model_tooltip')"
    :isActionable="canNetCpa"
    type="campaignType"
    :hasHint="hasHint"
  >
    <template #cardData>
      {{ $t(campaignTypes[campaignType]) }}
    </template>
    <template #dropdownMenu="{ closeMenu }">
      <div
        class="tw:px-4 tw:py-3 tw:text-sm tw:hover:bg-blue-200 tw:hover:text-blue-800 tw:rounded-lg"
        @click="openModal(closeMenu)"
      >
        {{ $t('rc_cpc_cpa_change') }}
      </div>
    </template>
  </Card>
</template>
<script setup>
import { computed } from 'vue'

import Card from '@/components/rateConnect/statusBar/Card.vue'

import { useRateConnect } from '@/components/rateConnect/useRateConnect'
import { useCampaign, usePartners } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const { openChangeCampaignModal } = useRateConnect()
const { currentPartner } = useCampaign(selectedAccommodationId)
const { partnersData } = usePartners(selectedAccommodationId)
const currentRCPartner = computed(() => {
  return partnersData.value?.find(item => {
    return item.partnerId === currentPartner.value
  })
})

const openModal = closeMenu => {
  appAnalytics.track(appAnalytics.events.RC_STATUS_BAR_MENU_OPTION_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    cardType: 'campaignType',
    option: 'Switch to pay-per-stay',
    campaignType: 'cpc',
  })
  openChangeCampaignModal()
  closeMenu()
}

const canNetCpa = computed(() => currentRCPartner.value?.canNetCpa)
defineProps({
  campaignType: {
    type: String,
    default: 'cpc',
  },
  hasHint: Boolean,
})
const campaignTypes = {
  cpc: 'rc_pay_per_click',
  netCpa: 'rc_pay_per_stay',
}
</script>
